module.exports = __webpack_public_path__ + "img/anzihong.0a7928dd.png";